module.exports = __webpack_public_path__ + "img/modal-mode.18b35605.svg";